import navbarStore from '@/store/navbar';
import { makeAutoObservable, runInAction } from 'mobx';
import { message } from 'antd';

class Store {
  isEdit = false;
  showDropdown = false;
  deleteIds = [];

  constructor() {
    makeAutoObservable(this);
  }

  doEidt = () => {
    runInAction(() => {
      this.isEdit = true;
    });
  };
  exitEidt = () => {
    runInAction(() => {
      this.isEdit = false;
      this.deleteIds = [];
    });
  };

  toggleDeleteId = id => {
    const index = this.deleteIds.indexOf(id);
    runInAction(() => {
      if (index !== -1) {
        this.deleteIds.splice(index, 1);
      } else {
        if (this.deleteIds.length >= 100) {
          message.warning('单次最多可选择100项');
          return;
        }
        this.deleteIds.push(id);
      }
    });
  };

  toggleDropdown = visible => {
    runInAction(() => {
      this.showDropdown = visible;
    });
  };

  checkAll() {
    runInAction(() => {
      if (navbarStore.historyList.length > 100) {
        message.warning('单次最多可选择100项');
        this.deleteIds = navbarStore.historyList.slice(0, 100).map(
          item => item.conversation_id
        );
      } else {
        this.deleteIds = navbarStore.historyList.map(
          item => item.conversation_id
        );
      }
    });
  }
  uncheckAll() {
    runInAction(() => {
      this.deleteIds = [];
    });
  }

  reset() {
    this.isEdit = false;
    this.showDropdown = false;
    this.deleteIds = [];
  }
}

const deleteMenuStore = new Store();
export default deleteMenuStore;
